const statusPledge = {
  GET: 1,
  GIVE: 2,
  BLOCK: 3,
};

const statusPledgeString = () => {
  let data = {};
  data[statusPledge.GET] = "گرفته شده";
  data[statusPledge.GIVE] = "پس داده شده";
  data[statusPledge.BLOCK] = "مسدود شده";

  return data;
};

export default {
  statusPledge,
  statusPledgeString,
};
